import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, FileEdit, Sparkles, Send, Share2,
  Rss, BarChart3, Settings as SettingsIcon, Users,
  Bell, Handshake, LogOut, Image as ImageIcon, Tv, SlidersHorizontal, Radio
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const items = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/posts", label: "Contenuti", icon: FileEdit, testid: "nav-posts" },
  { to: "/ai", label: "AI Assistant", icon: Sparkles, testid: "nav-ai" },
  { to: "/telegram", label: "Telegram", icon: Send, testid: "nav-telegram" },
  { to: "/telegram-partner-channels", label: "Partner Telegram", icon: Handshake, testid: "nav-telegram-partners" },
  { to: "/telegram-live", label: "Telegram Live", icon: Radio, testid: "nav-telegram-live" },
  { to: "/social", label: "Social Media", icon: Share2, testid: "nav-social" },
  { to: "/rss", label: "Feed RSS", icon: Rss, testid: "nav-rss" },
  { to: "/streaming", label: "Streaming", icon: Tv, testid: "nav-streaming" },
  { to: "/streaming-manager", label: "Streaming Manager", icon: Radio, testid: "nav-streaming-manager" },
  { to: "/automation", label: "Automazioni", icon: SlidersHorizontal, testid: "nav-automation" },
  { to: "/media", label: "Libreria", icon: ImageIcon, testid: "nav-media" },
  { to: "/stats", label: "Statistiche", icon: BarChart3, testid: "nav-stats" },
  { to: "/notifications", label: "Notifiche", icon: Bell, testid: "nav-notifications" },
  { to: "/users", label: "Utenti", icon: Users, testid: "nav-users", adminOnly: true },
  { to: "/settings", label: "Impostazioni", icon: SettingsIcon, testid: "nav-settings" },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <aside className="sticky top-0 z-40 flex w-full shrink-0 flex-col border-b border-slate-800 bg-slate-950 lg:h-screen lg:w-64 lg:border-b-0 lg:border-r" data-testid="sidebar">
      <div className="px-4 py-4 border-b border-slate-800 lg:px-6 lg:py-5">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => nav("/")}>
          <div className="w-9 h-9 rounded-md bg-blue-600 flex items-center justify-center font-black text-white text-lg">⚽</div>
          <div>
            <div className="font-extrabold text-white tracking-tight text-base leading-none">CalcioHub</div>
            <div className="text-[10px] tracking-[0.2em] text-blue-400 font-mono mt-1">AI · PLATFORM</div>
          </div>
        </div>
      </div>
      <nav className="flex gap-2 overflow-x-auto scrollbar-thin px-3 py-3 lg:block lg:flex-1 lg:space-y-0.5 lg:overflow-y-auto">
        {items.filter(i => !i.adminOnly || user?.role === "admin").map(({ to, label, icon: Icon, testid }) => (
          <NavLink key={to} to={to} end={to === "/"} data-testid={testid}
            className={({ isActive }) =>
              `flex shrink-0 items-center gap-2 rounded-md border px-3 py-2 text-sm transition-colors lg:gap-3 lg:py-2.5 ${
                isActive
                  ? "bg-blue-600/15 text-blue-300 border border-blue-500/30"
                  : "text-slate-400 hover:bg-slate-900 hover:text-slate-100 border border-transparent"
              }`
            }>
            <Icon size={17} strokeWidth={1.75} />
            <span className="font-medium">{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="hidden p-3 border-t border-slate-800 lg:block">
        <div className="px-3 py-2 mb-2">
          <div className="text-sm font-semibold text-white truncate" data-testid="sidebar-user-name">{user?.name}</div>
          <div className="text-[11px] uppercase tracking-wider font-mono text-blue-400">{user?.role}</div>
        </div>
        <button onClick={logout} data-testid="logout-btn"
          className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm text-slate-400 hover:bg-slate-900 hover:text-red-400 transition-colors">
          <LogOut size={16} /> Esci
        </button>
      </div>
    </aside>
  );
}
